import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { CardCheck, CardDetailedHeader, CardRadio } from '@gitbook/spine-react';

import { getUpgradeKeyForVisibility, PaidFeatureIndicator } from '../../../../Components';
import { useSiteContext, useUpgradeSite } from '../../../../state';

export function AudienceCardRadio(props: {
    value: api.SiteVisibility;
    title: React.ReactNode;
    description: string;
    icon?: React.ReactNode;
}) {
    const { value, title, description, icon } = props;
    const { site } = useSiteContext();
    const upgrade = useUpgradeSite(site, getUpgradeKeyForVisibility(value));

    return (
        <CardRadio value={value} autoFocus>
            <div className="flex items-center gap-4 p-4">
                <CardDetailedHeader
                    icon={icon}
                    title={title}
                    description={description}
                    badge={
                        <PaidFeatureIndicator
                            upgrade={upgrade}
                            isFeatureActive={site.visibility === value}
                        />
                    }
                />

                <CardCheck />
            </div>
        </CardRadio>
    );
}
